import { Colors, Icon } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React, { ChangeEvent, ReactNode, useState } from "react";
import { styled } from "styled-components";

type InputFieldPropsT = {
	label?: string;
	name: string;
	type: string;
	value: string;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
	inputContainerClass?: string;
	placeholder?: string;
	disabled?: boolean;
	mt?: string;
	mb?:string;
	ptb?: string;
	bradius?: string;
	elem?: ReactNode;
}

const InputField: React.FC<InputFieldPropsT> = ({
	label,
	name,
	type,
	value,
	onChange,
	inputContainerClass,
	placeholder = "Please Input",
	disabled = false,
	mt = "3px",
	mb = '0px',
	ptb = "10px",
  bradius="10px",
	elem,
}) => {
	const isPasswordField = type === "password";
	const [showPassword, setShowPassword] = useState(false);

	return (
		<div className={inputContainerClass ?? "mt-xlg"}>
			<div className={elem ? "display-flex align-center":""}>
			{label && <Label htmlFor={name}>{label}</Label>}
			{elem ? elem : <></>}
			</div>
			<InputWrapper>
				<CustomInputField
					name={name}
					value={value}
					onChange={onChange}
					placeholder={placeholder}
					disabled={disabled}
					type={isPasswordField && showPassword ? "text" : type}
					mt={mt}
					mb={mb}
					ptb={ptb}
					bradius={bradius}
				/>
				{isPasswordField && (
					<PasswordToggleButton
						type="button"
						aria-label={showPassword ? "Hide password" : "Show password"}
						onClick={() => setShowPassword((prev) => !prev)}
					>
						<Icon
							icon={showPassword ? IconNames.EYE_OFF : IconNames.EYE_OPEN}
							color={Colors.GRAY2}
							size={16}
						/>
					</PasswordToggleButton>
				)}
			</InputWrapper>
		</div>
	);
};

export default InputField;

const Label = styled.label`
    fontSize: "15px";
    color: ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY5 : Colors.GRAY1};
`;
const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
const PasswordToggleButton = styled.button`
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  color: ${Colors.GRAY2};
  &:focus-visible {
    outline: none;
  }
`;
const CustomInputField = styled.input<{ mt?: string , ptb: string, bradius?: string, mb?: string }>`
    width: 100%;
    background-color: ${({ theme: { darkMode } }) => darkMode ? Colors.DARK_GRAY3 : Colors.LIGHT_GRAY5};
    border: 1px solid ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY3};
    font-size: 15px;
    border-radius: ${({ bradius }) => bradius ?? "10px"};
    color: ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY4 : Colors.GRAY2};
	padding: ${({ ptb }) => `${ptb} 15px`};
    padding-right: 42px;
    margin-top: ${({ mt }) => mt ?? "3px"};
    margin-bottom: ${({ mb }) => mb ?? "0"};
    &:focus-visible{
      outline: none;
    }
    &::placeholder{
      color: ${({ theme: { darkMode } }) => darkMode ? Colors.GRAY1 : Colors.LIGHT_GRAY1};
    }
`;
